module.exports = __webpack_public_path__ + "images/anwbautoverzekering_small8927a68cd5303f04e83d76febbb847f6.png";